import { Spin } from "antd";
import React, { FC } from "react";

const Loader: FC = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: "20px",
        padding: "30px 50px",
        margin: "20px 0",
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
